<template>
    <b-modal
        :hide-footer="true"
        title=""
        centered
        size="md"
        id="agendar-proxima-avaliacao"
        :no-close-on-backdrop="true"
    >
        <div>
            <div class="row">
                <div class="col-12 px-3">
                    <h3 class="font-weight-bold">
                        Essa é a ultima avaliação ou deseja agendar uma nova?
                    </h3>
                </div>
                <form-calendar
                    class="mt-3"
                    label="Nova Data da proxima avaliação"
                    v-model="data_avaliacao"
                />
            </div>

            <div class="row pt-1 px-2 d-flex justify-content-end">
                <button @click="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save" /> {{ $t("Salvar") }}
                </button>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["id"],
    data() {
        return { data_avaliacao: "", loading: false };
    },
    methods: {
        submit() {
            this.loading = true;

            // if (this.data_avaliacao) {
            // 	this.data_avaliacao = moment(this.data_avaliacao, "YYYY-MM-DD").format(
            // 		"DD/MM/YYYY"
            // 	);
            // }

            axios
                .post(`api/dashboard/avaliacao/updateData`, {
                    data_avaliacao: this.data_avaliacao,
                    id: this.id,
                })
                .then((response) => {
                    this.$emit("update-data", this.data_avaliacao);
                    this.data_avaliacao = "";
                    this.loading = false;
                    this.$bvModal.hide("agendar-proxima-avaliacao");
                });
        },
    },
};
</script>
